import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import base64 from 'base64-arraybuffer';
import { stringToArrayBuffer } from './utils';
var BYTE_SIZE = 32; // 256 / 8

var HASH_ALGORITHM_NAME = 'SHA-256';
/**
 *
 * @param {ArrayBuffer} data
 */

var hash = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return window.crypto.subtle.digest({
              name: HASH_ALGORITHM_NAME
            }, data);

          case 2:
            result = _context.sent;
            return _context.abrupt("return", result);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function hash(_x) {
    return _ref.apply(this, arguments);
  };
}();

var hashBase64String = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dataString) {
    var data, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            data = base64.decode(dataString);
            _context2.next = 3;
            return hash(data);

          case 3:
            result = _context2.sent;
            return _context2.abrupt("return", base64.encode(result));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function hashBase64String(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var hashString = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dataString) {
    var data, result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            data = stringToArrayBuffer(dataString);
            _context3.next = 3;
            return hash(data);

          case 3:
            result = _context3.sent;
            return _context3.abrupt("return", base64.encode(result));

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function hashString(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

export default {
  BYTE_SIZE: BYTE_SIZE,
  HASH_ALGORITHM_NAME: HASH_ALGORITHM_NAME,
  hash: hash,
  hashBase64String: hashBase64String,
  hashString: hashString
};